export class WefatComponentRuntimeError extends Error {
    code;
    remediation;
    constructor(code, message, remediation) {
        super(`${code} ${message}`);
        this.name = 'WefatComponentRuntimeError';
        this.code = code;
        this.remediation = remediation;
    }
}
//# sourceMappingURL=component-error.js.map